/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthenticationResultNewDeviceMetadataStruct } from './AuthenticationResultNewDeviceMetadataStruct';
import {
    AuthenticationResultNewDeviceMetadataStructFromJSON,
    AuthenticationResultNewDeviceMetadataStructFromJSONTyped,
    AuthenticationResultNewDeviceMetadataStructToJSON,
    AuthenticationResultNewDeviceMetadataStructToJSONTyped,
} from './AuthenticationResultNewDeviceMetadataStruct';

/**
 * 
 * @export
 * @interface AuthenticationResult
 */
export interface AuthenticationResult {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResult
     */
    accessToken: string;
    /**
     * 
     * @type {number}
     * @memberof AuthenticationResult
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResult
     */
    idToken: string;
    /**
     * 
     * @type {AuthenticationResultNewDeviceMetadataStruct}
     * @memberof AuthenticationResult
     */
    newDeviceMetadata: AuthenticationResultNewDeviceMetadataStruct;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResult
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResult
     */
    tokenType: string;
}

/**
 * Check if a given object implements the AuthenticationResult interface.
 */
export function instanceOfAuthenticationResult(value: object): value is AuthenticationResult {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('newDeviceMetadata' in value) || value['newDeviceMetadata'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    return true;
}

export function AuthenticationResultFromJSON(json: any): AuthenticationResult {
    return AuthenticationResultFromJSONTyped(json, false);
}

export function AuthenticationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'expiresIn': json['expiresIn'],
        'idToken': json['idToken'],
        'newDeviceMetadata': AuthenticationResultNewDeviceMetadataStructFromJSON(json['newDeviceMetadata']),
        'refreshToken': json['refreshToken'],
        'tokenType': json['tokenType'],
    };
}

export function AuthenticationResultToJSON(json: any): AuthenticationResult {
    return AuthenticationResultToJSONTyped(json, false);
}

export function AuthenticationResultToJSONTyped(value?: AuthenticationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'expiresIn': value['expiresIn'],
        'idToken': value['idToken'],
        'newDeviceMetadata': AuthenticationResultNewDeviceMetadataStructToJSON(value['newDeviceMetadata']),
        'refreshToken': value['refreshToken'],
        'tokenType': value['tokenType'],
    };
}

